import React from 'react';
import PropTypes from 'prop-types';
import styles from './trajectory.module.scss';
import Milestone from '@components/milestone';
import Picture from '@components/picture';

const Trajectory = props => {
	const { title, milestones, illustration, imageAlt } = props;
	return (
		<section className={styles.section}>
			{!!title && <div className={styles.title}>{title}</div>}
			<div className={styles.container}>
				{milestones &&
					milestones.map((milestone, i) => {
						return (
							<div className={styles.milestone} key={i}>
								<Milestone order={i} {...milestone} />
							</div>
						);
					})}
			</div>
			{!!illustration && (
				<figure className={styles.media}>
					<Picture sources={illustration} imgClassName={styles.illustration} alt={imageAlt} />
				</figure>
			)}
		</section>
	);
};

Trajectory.propTypes = {
	title: PropTypes.string,
	milestones: PropTypes.array.isRequired,
	illustration: PropTypes.object,
	imageAlt: PropTypes.string
};

export default Trajectory;
